import * as React from 'react'
import { Link, type LinkProps } from 'react-router-dom'
import type { NodeLabel } from '@atbash-labs/ontology-core'
import { plantHref, type PlantNodeHrefContext } from '@atbash-labs/plantview-links'

export interface PlantHrefProps extends Omit<LinkProps, 'to'> {
  id: string
  /** When known, skips the entity-resolver hop via the surface registry. */
  label?: NodeLabel
  node?: PlantNodeHrefContext
}

/**
 * Shared Plant navigation link. Id-only links open `/plant/entity/:id`
 * (resolver redirects to bespoke pages). Pass `label` when the node type is
 * already known for a direct bespoke href.
 */
export function PlantHref({ id, label, node, ...props }: PlantHrefProps): React.ReactElement {
  return <Link to={plantHref(id, label, node)} {...props} />
}
